var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___TG5nWU",
  "Un": "AuthPageStyles.module__errorContainer___TG5nWU",
  "ik": "AuthPageStyles.module__errorIcon___TG5nWU",
  "gi": "AuthPageStyles.module__errorIconSvg___TG5nWU",
  "JU": "AuthPageStyles.module__errorTitle___TG5nWU",
  "kc": "AuthPageStyles.module__errorText___TG5nWU",
  "kL": "AuthPageStyles.module__container___TG5nWU",
  "TQ": "AuthPageStyles.module__entityHeader___TG5nWU",
  "Ep": "AuthPageStyles.module__entityDetails___TG5nWU",
  "Pp": "AuthPageStyles.module__entityText___TG5nWU",
  "j2": "AuthPageStyles.module__entityTitleWrapper___TG5nWU",
  "wD": "AuthPageStyles.module__entityTitle___TG5nWU",
  "N2": "AuthPageStyles.module__entityStats___TG5nWU",
  "So": "AuthPageStyles.module__entityStat___TG5nWU",
  "RS": "AuthPageStyles.module__onlineDot___TG5nWU",
  "FD": "AuthPageStyles.module__offlineDot___TG5nWU",
  "KA": "AuthPageStyles.module__statText___TG5nWU",
  "Wp": "AuthPageStyles.module__entityIconWrapper___TG5nWU",
  "fq": "AuthPageStyles.module__entityIcon___TG5nWU",
  "Ly": "AuthPageStyles.module__themeIconSpot___TG5nWU",
  "J3": "AuthPageStyles.module__themeIcon___TG5nWU",
  "Zd": "AuthPageStyles.module__form___TG5nWU",
  "ee": "AuthPageStyles.module__registrationNotice___TG5nWU",
  "Gr": "AuthPageStyles.module__bottomLink___TG5nWU",
  "fH": "AuthPageStyles.module__bottomLinkText___TG5nWU",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___TG5nWU",
  "cB": "AuthPageStyles.module__usernameHint___TG5nWU",
  "Jy": "AuthPageStyles.module__suggestionLink___TG5nWU",
  "LB": "AuthPageStyles.module__usernameError___TG5nWU",
  "$M": "AuthPageStyles.module__consentRow___TG5nWU",
  "t6": "AuthPageStyles.module__consentLabel___TG5nWU",
  "Rf": "AuthPageStyles.module__policyLink___TG5nWU",
  "ii": "AuthPageStyles.module__disabledContainer___TG5nWU",
  "aV": "AuthPageStyles.module__disabledText___TG5nWU",
  "ax": "AuthPageStyles.module__disabledSubtext___TG5nWU",
  "SO": "AuthPageStyles.module__disabledActions___TG5nWU",
  "ns": "AuthPageStyles.module__disabledActionLink___TG5nWU",
  "DD": "AuthPageStyles.module__title___TG5nWU",
  "Zo": "AuthPageStyles.module__giftIconContainer___TG5nWU",
  "ez": "AuthPageStyles.module__giftIcon___TG5nWU",
  "PM": "AuthPageStyles.module__entitySubtext___TG5nWU",
  "W$": "AuthPageStyles.module__subtext___TG5nWU",
};

module.exports = exports;
